/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper, { Navigation } from "swiper";
Swiper.use([Navigation]);

export function slider() {
    const sliderSelector = ".slider__slider";
    const slideContentSelector = ".slider__slide-content";
    const slideHeadlineSelector = ".slider__slide-headline";
    const slideTextSelector = ".slider__slide-text";
    const slideLinkSelector = ".slider__slide-link";
    const swiperActiveClass = ".swiper-slide-active";

    const contentBoxesSliderSelector = ".content-boxes__inner.swiper";
    const linkSliderSelector = ".link-slider__swipe-wrapper.swiper";
    const linkSliderContentSelector = ".link-slide__wrapper";

    const videoSliderSelector = ".video-slider__list-wrap.swiper";

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const setSlideContent = function (slideElement) {
        const slideContent = document.querySelector(slideContentSelector);
        if (slideContent != null) {
            if (typeof slideElement.dataset.slideheadline !== undefined) {
                slideContent.querySelector(slideHeadlineSelector).innerHTML = slideElement.dataset.slideheadline;
            }
            if (typeof slideElement.dataset.slidetext !== undefined) {
                slideContent.querySelector(slideTextSelector).innerHTML = slideElement.dataset.slidetext;
            }
            if (typeof slideElement.dataset.slidelink !== undefined) {
                const slideLink = slideContent.querySelector(slideLinkSelector);
                slideLink.innerHTML = slideElement.dataset.slidelinkname;
                slideLink.href = slideElement.dataset.slidelink;
                slideLink.target = slideElement.dataset.slidelinktarget;
            }

            slideContent.style.opacity = 1;
        }
    };

    const init = function () {
        var slider = new Swiper(sliderSelector, {
            speed: 500,
            loop: false,
            slidesPerView: 1,
            observer: true,
            observeParents: true,
            navigation: {
                prevEl: '.button-prev',
                nextEl: '.button-next'
            },
            on: {
                afterInit: function () {
                    const activeSlide = document.querySelector(swiperActiveClass);
                    setSlideContent(activeSlide);

                },
                slideChangeTransitionStart: function (swiper) {
                    document.querySelector(slideContentSelector).style.opacity = 0;
                },
                slideChangeTransitionEnd: function (swiper) {
                    const activeSlide = document.querySelector(
                        swiperActiveClass
                    );
                    setSlideContent(activeSlide);
                }
            }
        });

        var contentBoxSlider = new Swiper(contentBoxesSliderSelector, {
            speed: 500,
            loop: true,
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 31,
            breakpoints: {
                666: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3
                }
            },
            navigation: {
                prevEl: '.content-boxes__slider-navigation-prev',
                nextEl: '.content-boxes__slider-navigation-next'
            },
            on: {
                slideChange: () => {
                    handleSlideChange();
                },
                slideChangeTransitionEnd: (swiper) => {
                    handleSlideChangeTransitionEnd(swiper);

                }

            }
        });

        const linkSliders = [];
        const linkSliderElements = document.querySelectorAll(linkSliderSelector);
        if (linkSliderElements) {
            linkSliderElements.forEach(slider => {
                linkSliders.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: "4",
                    spaceBetween: 15,
                    navigation: {
                        prevEl: '#' + slider.dataset.id + ' .link-slider__button-prev',
                        nextEl: '#' + slider.dataset.id + ' .link-slider__button-next'
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }

                    }
                }));

            });
        };

        const videoSliders = [];
        const videoSliderElements = document.querySelectorAll(videoSliderSelector);
        if (videoSliderElements) {
            videoSliderElements.forEach(slider => {

                videoSliders.push(new Swiper(slider, {
                    speed: 500,
                    spaceBetween: 15,
                    loop: false,
                    slidesPerView: "auto",
                    breakpoints: {
                        1500: {
                            slidesOffsetAfter: 15
                        }
                    },
                    spaceBetween: 15,
                    slidesOffsetAfter: 15,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .video-slider__slider-navigation-next",
                        prevEl: '#' + slider.dataset.componentId + " .video-slider__slider-navigation-prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }
    }

    init();
}



// WEBPACK FOOTER //
// ./src/scripts/partials/slider.js